__turbopack_context__.v({
  "className": "figtree_2833bc06-module__fWNa_a__className",
  "variable": "figtree_2833bc06-module__fWNa_a__variable",
});
